import { useEffect, useRef, useState } from 'react';
import CryptoJS from 'crypto-js';
import { useSearchParams } from 'react-router-dom';

import { useSuspenseGetMebiconn } from '../model/query';

export const Body = () => {
  const submitRef = useRef(null);
  const [params, setParams] = useState('');
  const [searchParams] = useSearchParams();
  const hspId = searchParams.get('hspId');
  const ptMpiKey = searchParams.get('ptMpiKey');
  const mebiBaseUrl = searchParams.get('mebiBaseUrl');
  const rcorgNo = searchParams.get('rcorgNo');

  const {
    data: {
      data: { mebiUrl, ptNo, siteCd },
    },
  } = useSuspenseGetMebiconn({ hspId, ptMpiKey, mebiBaseUrl, rcorgNo });

  useEffect(() => {
    function encryptAES(message, key) {
      var keyHex = CryptoJS.enc.Utf8.parse(key);

      var encrypted = CryptoJS.AES.encrypt(message, keyHex, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: CryptoJS.enc.Hex.parse('00000000000000000000000000000000'), // IV 없이 암호화
      });

      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }

    var message = `PTNO=${ptNo}&SITECD=${siteCd}`;
    var key = 'BESTSURVEY!2020@';

    var encryptedMessage = encryptAES(message, key);

    setParams(encryptedMessage);
  }, []);

  useEffect(() => {
    if (params) {
      submitRef.current.click();
    }
  }, [params]);

  return (
    <>
      <div id='test' style={{ visibility: 'hidden' }}>
        <form action={mebiUrl} method='post'>
          <label htmlFor='name'>USRDATA:</label>
          <input type='text' id='USRDATA' name='USRDATA' defaultValue={params} />
          <input type='submit' value='submit' ref={submitRef} />
        </form>
      </div>
    </>
  );
};
